import * as React from "react";
import { Button, Link } from "@skbkontur/react-ui";

import { useMetrics } from "../../../../Internals/Metrics/MetricsProviderContext";
import { OPEN_PO_PD_PROTOCOL, RUN_PO_PD_CHECK } from "../../../../metricsAction";
import {
    CandyPopdProtocolState,
    PopdResultCode,
} from "../../../../../../../Common/CandyApiClient/Types/ErrorLog/CandyPopdProtocol";

import {
    PopdProtocolBlock,
    PopdProtocolButtonWrapper,
    PopdProtocolHeader,
    PopdProtocolHint,
    PopdProtocolInfo,
} from "./PopdProtocol.styles";
import { PopdProtocolErrorText } from "./PopdProtocolErrorText";

export interface PopdProtocolProps {
    hasInternalErrors: boolean;
    runCheckByPopd: () => Promise<void>;
    protocol?: CandyPopdProtocolState;
}

export const PopdProtocol = (props: PopdProtocolProps) => {
    const track = useMetrics();

    const generationSuccessful = props.protocol?.resultCode === PopdResultCode.Ok;
    const isSuccessful =
        generationSuccessful && props.protocol?.errorsCount === 0 && props.protocol?.warningsCount === 0;
    const canRunCheck = !props.hasInternalErrors && props.protocol?.resultCode == undefined;

    const handleOpenProtocol = () => {
        track(OPEN_PO_PD_PROTOCOL);
    };

    const handleRunCheck = async () => {
        track(RUN_PO_PD_CHECK);
        await props.runCheckByPopd();
    };

    return (
        <div>
            <PopdProtocolHint>
                Часть проверок пока не реализована в Экстерне. В протоколе проверки СФР могут быть выявлены
                дополнительные ошибки.
            </PopdProtocolHint>
            <PopdProtocolBlock hasInternalErrors={props.hasInternalErrors} isSuccessful={isSuccessful}>
                <PopdProtocolInfo>
                    <PopdProtocolHeader>Протокол проверки СФР</PopdProtocolHeader>
                    <PopdProtocolErrorText
                        protocol={props.protocol}
                        isSuccessful={isSuccessful}
                        canRunCheck={canRunCheck}
                        hasInternalErrors={props.hasInternalErrors}
                    />
                </PopdProtocolInfo>
                {canRunCheck && (
                    <PopdProtocolButtonWrapper>
                        <Button
                            use={"default"}
                            size={"small"}
                            loading={props.protocol?.isChecking}
                            onClick={handleRunCheck}>
                            Запустить
                        </Button>
                    </PopdProtocolButtonWrapper>
                )}
                {generationSuccessful && (
                    <PopdProtocolButtonWrapper>
                        <Link
                            href={props.protocol?.contentDriveUri}
                            target={"_blank"}
                            rel={"noreferrer"}
                            onClick={handleOpenProtocol}>
                            <Button use={"default"} size={"small"}>
                                Скачать
                            </Button>
                        </Link>
                    </PopdProtocolButtonWrapper>
                )}
            </PopdProtocolBlock>
        </div>
    );
};
